export default function DepositPopupImage({ iosPreviewUrl, setIosPreviewUrl }) {

    return (iosPreviewUrl && setIosPreviewUrl) && (
        <div
            style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.9)',
                zIndex: 99999,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
            }}
            onClick={() => setIosPreviewUrl(null)}
        >
            <div style={{ color: '#fff', marginBottom: '20px', fontSize: '18px', textAlign: 'center', fontWeight: 'bold' }}>
                แตะค้างที่รูปเพื่อบันทึก <br />
                <span style={{ fontSize: '14px', opacity: 0.8, fontWeight: 'normal' }}>(Tap & Hold to Save)</span>
            </div>

            <img
                src={iosPreviewUrl}
                alt="Save this QR"
                style={{
                    maxWidth: '100%',
                    maxHeight: '70vh',
                    borderRadius: '10px',
                    boxShadow: '0 0 20px rgba(255,255,255,0.2)',
                    border: '2px solid white'
                }}
                onClick={(e) => e.stopPropagation()}
            />

            <button
                onClick={() => setIosPreviewUrl(null)}
                style={{
                    marginTop: '25px',
                    padding: '10px 30px',
                    background: '#fff',
                    color: '#000',
                    border: 'none',
                    borderRadius: '30px',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                }}
            >
                ปิดหน้าต่าง
            </button>
        </div>
    );
}